import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

export const FormInputText = (props) => {
  const {
    name,
    control,
    testId,
    label,
    type,
    shrink,
    multiline,
    rows,
    disabled,
    register,
    minValue,
    maxValue,
    errors,
    helperText,
    placeholder,
    readOnly,
    onKeyDown,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      register={register}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          onChange={onChange}
          value={value == null ? '' : value}
          disabled={disabled}
          label={label}
          type={type}
          variant="standard"
          multiline={multiline}
          error={errors}
          helperText={helperText}
          placeholder={placeholder}
          rows={rows}
          InputLabelProps={{
            shrink: shrink,
          }}
          InputProps={{
            'data-testid': testId,
            inputProps: { min: minValue, max: maxValue },
            readOnly: readOnly,
            onKeyDown: onKeyDown,
          }}
          style={{ width: '100%', marginBottom: '20px' }}
        />
      )}
    />
  );
};
